// Static imports
import CashMain from '@/views/member/cash'
import InApply from '@/views/member/cash/pages/in/apply'
import InReport from '@/views/member/cash/pages/in/report'
import OutApply from '@/views/member/cash/pages/out/apply'
import OutReport from '@/views/member/cash/pages/out/report'
import AdminList from '@/views/member/cash/pages/admin/list'
import CashVarianceHistory from '@/views/member/cash/pages/cashVarianceHistory'
import Coupon from '@/views/member/cash/pages/coupon'

export const cashBoth = {
  name: 'UserCashBoth',
  path: '/user/cash',
  component: CashMain,
  redirect: {
    name: 'userInApply'
  },
  props: true,
  meta: {
    layout: 'default',
    isActive: false,
    text: '입출금 관리',
    icon: 'icon_inout',
    code: 'LV070000'
  },
  children: [
    {
      name: 'userInApply',
      path: '/user/cash/in/apply',
      component: InApply,
      props: true,
      meta: {
        menuMember: true,
        text: '입금신청내역',
        code: 'LV070100'
      }
    },
    {
      name: 'depositReport',
      path: '/user/cash/in/report',
      component: InReport,
      meta: {
        menuMember: true,
        text: '입금내역조회',
        code: 'LV070200'
      }
    },
    {
      name: 'userOutApply',
      path: '/user/cash/out/apply',
      props: true,
      component: OutApply,
      meta: {
        menuMember: true,
        text: '출금신청내역',
        code: 'LV070300'
      }
    },
    {
      name: 'withdrawReport',
      path: '/user/cash/out/report',
      component: OutReport,
      meta: {
        menuMember: true,
        text: '출금내역조회',
        code: 'LV070400'
      }
    },
    {
      name: 'adminReport',
      path: '/user/cash/admin/list',
      component: AdminList,
      meta: {
        menuMember: true,
        text: '관리자 지급/회수',
        code: 'LV070500'
      }
    },
    {
      name: 'cashVarianceHistory',
      path: '/user/cash/cashVarianceHistory',
      component: CashVarianceHistory,
      meta: {
        menuMember: true,
        text: '캐시변동내역',
        code: 'LV070600'
      }
    },
    {
      name: 'coupon',
      path: '/user/cash/coupon',
      component: Coupon,
      meta: {
        menuMember: true,
        text: '쿠폰 관리',
        code: 'LV070700'
      }
    }
  ]
}

export const cashIn = {
  name: 'CashIn',
  path: '/cash/in',
  component: CashMain,
  redirect: {
    name: 'depositApply'
  },
  props: true,
  meta: {
    layout: 'default',
    isActive: false,
    text: '입금 관리',
    icon: 'fas fa-money-check'
  },
  children: [
    {
      name: 'depositApply',
      path: '/cash/in/apply',
      component: InApply,
      meta: {
        menuMember: true,
        text: '입금신청내역'
      }
    },
    {
      name: 'depositReport',
      path: '/cash/in/report',
      component: InReport,
      meta: {
        menuMember: true,
        text: '입금내역조회'
      }
    }
  ]
}

export const cashOut = {
  name: 'CashOut',
  path: '/cash/out',
  component: CashMain,
  redirect: {
    name: 'withdrawApply'
  },
  meta: {
    layout: 'default',
    isActive: false,
    text: '출금 관리',
    icon: 'fas fa-money-bill-alt'
  },
  children: [
    {
      name: 'withdrawApply',
      path: '/cash/out/apply',
      component: OutApply,
      meta: {
        menuMember: true,
        text: '출금신청내역'
      }
    },
    {
      name: 'withdrawReport',
      path: '/cash/out/report',
      component: OutReport,
      meta: {
        menuMember: true,
        text: '출금내역조회'
      }
    }
  ]
}
